__turbopack_context__.v({
  "author": "quoted-tweet-header-module__Su4JYa__author",
  "authorText": "quoted-tweet-header-module__Su4JYa__authorText",
  "avatar": "quoted-tweet-header-module__Su4JYa__avatar",
  "avatarSquare": "quoted-tweet-header-module__Su4JYa__avatarSquare",
  "header": "quoted-tweet-header-module__Su4JYa__header",
  "username": "quoted-tweet-header-module__Su4JYa__username",
});
